<template>
  <tr>
    <td>
      {{ item.value }}
    </td>
    <td>
      {{ item.notes }}
    </td>
    <td>
      <div
        v-if="$userCheckAccess({ abilities: 'edit_client_contacts', })"
        class="buttons align-center justify-space-between">
        <div>
          <v-checkbox
            v-model="item.is_primary"
            dense
            hide-details
            on-icon="mdi-radiobox-marked"
            off-icon="mdi-radiobox-blank"
            :label="'Show in the invoice'"
            @change="setNewPrimary"
          />
        </div>
        <div class="buttons">
          <WorkClientContactModal :create="false" :id="item.id" :type="type" />
          <DeleteModal
            :item="item"
            :text="
              localStorage.translations.pages['setting-client']['contacts-dialog-delete'][
                'udalit-kontakt'
              ] +
              ' ' +
              item.notes
            "
          />
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import WorkClientContactModal from 'components/workClient/contact/WorkClientContactModal'
import DeleteModal from 'components/DeleteModal'
import {mapActions} from "vuex";

export default {
  name: 'WorkClientContactTableItem',
  components: { WorkClientContactModal, DeleteModal },
  props: ['item', 'type'],
  computed: {
    params() {
      return {
        limit: this.type === 'email' ? this.$route.query.address_limit : this.$route.query.phone_limit,
        page: this.type === 'email' ? this.$route.query.address_page : this.$route.query.phone_page,
        id: this.$route.params.id,
      }
    },
  },
  methods: {
    ...mapActions('workClientContact', [
      'onWorkClientContactGridEmail',
      'onWorkClientContactGridPhone',
      'onWorkClientContactUpdate',
    ]),
    async setNewPrimary() {
      await this.onWorkClientContactUpdate(this.item)
        .then(() => {
          if (this.type === 'email')
            this.onWorkClientContactGridEmail(this.params)
          else
            this.onWorkClientContactGridPhone(this.params)
        })
    }
  },
}
</script>

<style lang="scss" scoped>
td {
  &:nth-child(1) {
    width: auto;
  }

  &:nth-child(2) {
    width: max-content;
  }

  &:nth-child(3) {
    width: auto;
  }

  &:nth-child(4) {
    width: auto;
  }
}
</style>